import { homeTheme } from '@brand/themes/homeTheme';
import { Dialog, IconButton, Stack, SxProps, Theme, ThemeProvider, Typography } from '@mui/material';
import { ReactComponent as CloseIcon } from 'assets/icons/Cross.svg';
import { DialogComponentProps } from 'common/hooks/useDialog';
import _ from 'lodash';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { styles } from './GuaranteesDialog.styles';

export interface GuaranteesDialogProps extends DialogComponentProps<void> {
  icon?: React.ReactNode;
  subtitle?: string;
  title: string;
  content: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const GuaranteesDialog: FC<GuaranteesDialogProps> = ({
  content,
  icon,
  isOpen,
  onResolve,
  subtitle,
  sx,
  title,
}) => {
  const { t } = useTranslation();
  const newTheme = useCallback((theme: Theme) => {
    return _.merge(_.cloneDeep(theme), homeTheme);
  }, []);

  return (
    <ThemeProvider theme={newTheme}>
      <Dialog
        PaperProps={{ sx: { ...styles.paper, ...(sx ?? {}) } as SxProps<Theme> }}
        disableEnforceFocus={true}
        onClose={() => onResolve()}
        open={isOpen}
      >
        <IconButton
          aria-label={t('common:close')}
          color="tertiaryButton"
          onClick={() => onResolve()}
          size="medium"
          sx={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>
        <Stack spacing={3}>
          <Stack alignItems="center" spacing={1}>
            {icon}
            <Typography textAlign="center" variant="headlineL">
              {title}
            </Typography>
            {subtitle && (
              <Typography color="textSecondary" textAlign="center" variant="bodyM">
                {subtitle}
              </Typography>
            )}
          </Stack>
          {content}
        </Stack>
      </Dialog>
    </ThemeProvider>
  );
};
